module.exports = __webpack_public_path__ + "src/assets/images/search.1656b4209ae2af8d9a3a0900a26e6e8f.svg";